import axios from "axios";
import BASE_URL from "../constants/baseUrls";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const useAutomaticReserveBooking = setLoading => {
    const { t } = useTranslation();

    const accessToken = localStorage.getItem("accessToken");
    const selectedFlight = JSON.parse(sessionStorage.getItem("selectedFlight")) || {};
    const selectedIntFlight = JSON.parse(sessionStorage.getItem("selectedIntFlight")) || {};
    const flightPassengers = JSON.parse(sessionStorage.getItem("flightPassengers")) || {};
    const generalInformation = JSON.parse(sessionStorage.getItem("generalInformation")) || {};
    const intFlightInformation = JSON.parse(sessionStorage.getItem("intFlightInformation")) || {};
    const intFlightPassengers = JSON.parse(sessionStorage.getItem("intFlightPassengers")) || {};
    const domesticFlightInformation = JSON.parse(sessionStorage.getItem("domesticFlightInformation")) || {};
    const selectedReservation = JSON.parse(sessionStorage.getItem("selectedReservation")) || {};
    const { departureDate } = intFlightInformation;
    const { isFlightInternational } = generalInformation;
    const { departure, destination } = domesticFlightInformation;
    const isSelectedReserve = Object.keys(selectedReservation).length > 0;

    const formattedPassengerData = passenger => ({
        gender: passenger?.gender?.id === 1 ? "MALE" : "FEMALE",
        type:
            passenger?.passenger_type === "ADL"
                ? "ADT"
                : ["adt", "chd", "inf"].includes(passenger?.type?.toLowerCase())
                  ? passenger.type.toUpperCase()
                  : passenger?.passenger_type || passenger?.type,

        first_name: passenger?.english_first_name,
        last_name: passenger?.english_last_name,
        english_first_name: passenger?.english_first_name,
        english_middle_name: null,
        english_last_name: passenger?.english_last_name,
        nationality: passenger?.nationality?.parto_iata,
        ...((isFlightInternational || passenger.nationality?.id !== 1) && {
            passport_number: passenger?.passport_no,
            passport_country: passenger?.passport_country?.parto_iata,
            passport_expire_date: passenger?.passport_exp_date,
            passport_issue_date: null,
        }),
        ...(passenger.nationality?.id === 1 && {
            national_code: passenger?.national_code,
        }),
        national_code: passenger?.national_code,
        birthdate: passenger?.birthdate,
    });

    const domesticPassengerMap = flightPassengers.passengers?.map(formattedPassengerData);
    const intPassengerMap = intFlightPassengers.passengers?.map(formattedPassengerData);
    const passengerMap = isFlightInternational ? intPassengerMap : domesticPassengerMap;

    const domesticData = {
        departure_city: departure?.id,
        destination_city: destination?.id,
        ...selectedFlight,
        passengers: passengerMap,
    };

    const intData = {
        departure_airport: intFlightInformation?.departure?.id,
        destination_airport: intFlightInformation?.destination?.id,
        ...selectedIntFlight,
        departure_date: departureDate,
        passengers: passengerMap,
        departure_time: selectedIntFlight?.segments?.[0]?.departure_time,
    };

    const data = isFlightInternational ? intData : domesticData;

    const automaticReserveBooking = async () => {
        try {
            const response = !isSelectedReserve
                ? await axios.post(`${BASE_URL}/notification/reserve/manage/`, data, {
                      headers: {
                          Authorization: `Bearer ${accessToken}`,
                          "Content-Type": "application/json",
                      },
                  })
                : await axios.patch(`${BASE_URL}/notification/reserve/manage/${selectedReservation?.item?.id}/`, data, {
                      headers: {
                          Authorization: `Bearer ${accessToken}`,
                          "Content-Type": "application/json",
                      },
                  });

            if (response.status === 200) {
                !isSelectedReserve
                    ? toast.success(t("requestSubmittedSuccessfully"), { toastId: "custom-id-yes" })
                    : toast.success(response?.data?.message, { toastId: "edit-id-yes" });
            }
        } catch (error) {
            toast.error(t("errorMessage"), { toastId: "custom-id-yes" });
        }
    };
    return {
        automaticReserveBooking,
    };
};
export default useAutomaticReserveBooking;
